import { createAction, props } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { ExtensionOption } from '../../extension-register/models/extension-option.interface';
import { QueueHistoryFilterOptions } from '../models/queue-history-filter-option';
import { LoggedInQueueMemberStatus } from '../models/queue-history-register-queue-members.model';
import { QueueHistoryRegisterListItem } from '../models/queue-history-register-results.model';

const area = 'QueueHistory Register';
export const queueHistoryRegisterAdapterActions = createRegisterActions<QueueHistoryRegisterListItem>(area);

export const queueHistoryRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{
      filters: QueueHistoryFilterOptions[];
      queueExtensionId: number | null;
      orderingOptions?: OrderingOption[];
   }>()
);

export const loadAccountQueueMembers = createAction(
   `[${area}] Load Account Queue Members`,
   props<{ accountId: number; reloadQueueHistoryRegister: boolean }>()
);

export const loadAccountQueueMembersSuccess = createAction(
   `[${area}] Load Account Queue Members Success`,
   props<{
      queueExtensions: ExtensionOption[];
      allAccountQueueMembers: LoggedInQueueMemberStatus[];
      reloadQueueHistoryRegister: boolean;
   }>()
);

export const loadAccountQueueMembersFailure = createAction(
   `[${area}] Load Account Queue Members Failure`,
   props<SingleGraphError>()
);

export const setOrderingOptionsFromSessionStorage = createAction(
   `[${area}] Set Ordering Options From Session Storage`,
   props<{ orderingOptions: OrderingOption[] | null }>()
);

export const clearQueueCall = createAction(
   `[${area}] Clear Queue Call`,
   props<{ queueHistory: QueueHistoryRegisterListItem }>()
);

export const openCallDetailsForActive = createAction(
   `[${area}] Open Call Details For active`,
   props<{ queueHistory: QueueHistoryRegisterListItem }>()
);

export const openCallDetailsForCallDetail = createAction(
   `[${area}] Open Call Details for Non active`,
   props<{ queueHistory: QueueHistoryRegisterListItem }>()
);

export const clearQueueCallSuccess = createAction(`[${area}] Clear Queue Call Success`);

export const clearQueueCallFailure = createAction(`[${area}] Clear Queue Call Failure`, props<SingleGraphError>());

export const sendToEmptyExitRoute = createAction(
   `[${area}] Send To Empty Exit Route`,
   props<{ queueHistory: QueueHistoryRegisterListItem }>()
);

export const sendToEmptyExitRouteSuccess = createAction(`[${area}] Send To Empty Exit Route Success`);

export const sendToEmptyExitRouteFailure = createAction(
   `[${area}] Send To Empty Exit Route Failure`,
   props<SingleGraphError>()
);
